import React, { useContext } from 'react';
import { SidebarContext } from '../../App';

export const FormFooter = () => {
	const currentYear = new Date().getFullYear();
	const { sidebarDisplay = true } = useContext(SidebarContext) || {};
	return (
		<div className={`Form_footer ${sidebarDisplay ? 'form_footer_left' : 'm-0'}`} >
			<div className="Privacy_termsbox">
				<ul>
					<li> ©{currentYear} ECODRISIL, All Rights Reserved.</li>
					<li>
						<a className="" target="_blank" href="https://ecodrisil.com/privacy-policy">
							Privacy Policy
						</a>
					</li>
					<li>
						<a className="" target="_blank" href="https://ecodrisil.com/terms-of-use">
							Terms & Conditions
						</a>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default FormFooter;